import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className={`navigation-container1 ${props.rootClassName} `}>
      <div id="navigation-mobile-overlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <div className="navigation-logo-container">
            <img
              alt="GESVET Logo"
              src="https://play-lh.googleusercontent.com/fLpS-K7_L17K33N3oF-O8X9S8X9S8X9S8X9S8X9S8X9S8X9S8X9S8X9S8X9S8X9S"
              className="navigation-image1"
            />
            <span className="section-title navigation-brand-name">GESVET</span>
          </div>
          <button
            id="navigation-mobile-close"
            aria-label="Cerrar menú"
            className="navigation-mobile-close"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Home</span>
            </div>
          </Link>
          <div className="navigation-overlay-link">
            <span>Servicios</span>
          </div>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Funcionalidades</span>
            </div>
          </Link>
          <Link to="/">
            <div className="navigation-overlay-link">
              <span>Beneficios</span>
            </div>
          </Link>
          <div className="navigation-overlay-link">
            <span>Soporte</span>
          </div>
          <div className="navigation-overlay-cta">
            <Link to="/">
              <div className="btn btn-primary btn-lg">
                <span>Descargar App</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay, .navigation-overlay-link, .navigation-overlay-cta {
  transition: none !important;
  transform: none !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const mobileToggle = document.getElementById("navigation-mobile-toggle")
  const mobileClose = document.getElementById("navigation-mobile-close")
  const mobileOverlay = document.getElementById("navigation-mobile-overlay")
  const body = document.body

  function openMenu() {
    mobileOverlay.classList.add("is-active")
    mobileToggle.setAttribute("aria-expanded", "true")
    body.style.overflow = "hidden"
  }

  function closeMenu() {
    mobileOverlay.classList.remove("is-active")
    mobileToggle.setAttribute("aria-expanded", "false")
    body.style.overflow = ""
  }

  mobileToggle.addEventListener("click", openMenu)
  mobileClose.addEventListener("click", closeMenu)

  // Close menu when clicking on a link
  const mobileLinks = document.querySelectorAll(".navigation-overlay-link")
  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  // Close menu on ESC key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-active")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <nav className="custom-nav-wrapper">
        <div className="navigation-nav-container nav-container">
          <div className="nav-brand">
            <img
              alt={props.imageAlt2}
              src={props.imageSrc2}
              className="navigation-image2"
            />
          </div>
          <button
            id="mobileToggle"
            aria-label="Abrir menú"
            className="mobile-menu-btn"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
          <div id="navContent" className="nav-menu-group">
            <ul className="nav-links-list">
              <li className="nav-item">
                <Link to="/">
                  <div className="navigation-thq-nav-link-item-elm1 nav-link-item">
                    <span>Inicio</span>
                  </div>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/aplicacion">
                  <div className="navigation-thq-nav-link-item-elm2 nav-link-item">
                    <span>Aplicacion</span>
                  </div>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/bluetooth">
                  <div className="navigation-thq-nav-link-item-elm3 nav-link-item">
                    <span>Bluetooth</span>
                  </div>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/soporte">
                  <div className="navigation-thq-nav-link-item-elm4 nav-link-item">
                    <span>Soporte</span>
                  </div>
                </Link>
              </li>
              <li className="nav-item list-item">
                <a
                  href="https://play.google.com/store/apps/details?id=com.exeo.gesvet"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="navigation-thq-btn-elm2 btn btn-primary">
                    <span>Descargar App</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div>
        <div className="navigation-container7">
          <Script
            html={`<script>
(function(){
  const mobileToggle = document.getElementById("mobileToggle")
  const navContent = document.getElementById("navContent")

  if (mobileToggle && navContent) {
    mobileToggle.addEventListener("click", () => {
      navContent.classList.toggle("is-open")

      // Toggle icon between menu and close
      const isOpened = navContent.classList.contains("is-open")
      mobileToggle.innerHTML = isOpened
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>'
    })

    // Close menu when clicking a link (mobile)
    const navLinks = navContent.querySelectorAll(".nav-link-item")
    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        navContent.classList.remove("is-open")
        mobileToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>'
      })
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Navigation.defaultProps = {
  rootClassName: '',
  imageSrc2: '/images/logo%20gesvet%20recorte-200h.jpg',
  imageAlt2: 'image',
}

Navigation.propTypes = {
  rootClassName: PropTypes.string,
  imageSrc2: PropTypes.string,
  imageAlt2: PropTypes.string,
}

export default Navigation
